import React, { useState, useEffect } from 'react';
import { BeatLoader } from 'react-spinners';
import ErrorComponent from '../ErrorComponent/ErrorComponent';
import Popover from "@mui/material/Popover";
import { useSelector, useDispatch } from 'react-redux';
import { openDrawer } from '../../actions/drawerActions';
import { DeletePortfolio } from "../../Apis/DeletePortfolio";
import { fetchPortfolio } from '../../actions/portfolioActions';
import { addZeroes } from "../../Utilities/AddZeros";
import { fetchPortfolioDetailsIfNeeded, addTicker, deleteTicker } from '../../actions/portfolioDetailsActions';
import { handleApiError, showConfirmNotification } from '../../actions/notificationActions';
import Toaster from '../../Components/Toaster/Toaster';
import TagManager from 'react-gtm-module';

function PortfolioDetails({ portfolioId, portfolioName, hasSchwabAccount }) {

    var currObj = {
        style: "currency",
        currency: "USD",
    };
    const dispatch = useDispatch();

    const [loadingState, setLoadingState] = useState({
        fetchDetails: false,
        addTicker: false,
        deleteTicker: false,
    });

    const [ticker, setTicker] = useState('');
    const [quantity, setQuantity] = useState('');
    const [errorMessage, setErrorMessage] = useState("");
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [confirmPopup, setConfirmPopup] = React.useState(false);
    const [confirmPopupMessage, setConfirmPopupMessage] = React.useState("");
    const portfolioDetails = useSelector(state => state.portfolioDetails[portfolioId]);
    const availableTickers = useSelector(state => state.availableTickers.availableTickers);
    const [hedgeableFlag, setHedgeableFlag] = useState(false);

    const toggleHedgeableFlag = () =>{
        setHedgeableFlag(!hedgeableFlag);
    }

    useEffect(() => {
        if (portfolioDetails && (!portfolioDetails.details?.PortfolioLineItem?.Hedgeable || portfolioDetails.needsUpdate) && !portfolioDetails.isLoading) {
            dispatch(fetchPortfolioDetailsIfNeeded(portfolioId));
        }
    }, [portfolioId, dispatch, portfolioDetails]);
    
    const handleTickerChange = (e) => {
        const referenceTicker = availableTickers.find(refTicker => refTicker.symbol === e.target.value.toUpperCase());
        if(!referenceTicker){
            setErrorMessage("Symbol not recognized");
        }
        else{
            setErrorMessage('');
        }
        setTicker(e.target.value.toUpperCase());
    };

    const handleQuantityChange = (e) => {
        const value = e.target.value;
        const quantityNum = parseFloat(value);
        if (value && (isNaN(quantityNum) || quantityNum <= 0)) {
            setErrorMessage("Please enter a quantity greater than 0.");
        } else {
            setErrorMessage("");
        }

        setQuantity(value);
    };

    const handleAddTicker = () => {
        const quantityNum = parseFloat(quantity);
        if (!ticker && !quantityNum) {
            setErrorMessage("Symbol and quantity field can not be empty");
            return;
        }
        else if (isNaN(quantityNum) || quantityNum <= 0) {
            setErrorMessage("Please enter a quantity greater than 0.");
            return;
        }
        else if (!ticker) {
            setErrorMessage("Symbol field can not be empty");
            return;
        }
        else
        setLoadingState(prev => ({ ...prev, addTicker: true }));
            dispatch(addTicker(portfolioId, ticker, quantity))
                .finally(() => {
                    setLoadingState(prev => ({ ...prev, addTicker: false }));
                    setTicker('');
                    setQuantity('');
                    setErrorMessage("");
                    TagManager.dataLayer({
                        dataLayer: {
                          'event': 'Add Ticker',
                          'userType':sessionStorage.getItem("selectedAcType"),
                          'user_id': sessionStorage.getItem("clientId")
                        },
                      });
                });
    };

    const handleDeleteTicker = (ticker) => {
        setLoadingState(prev => ({ ...prev, deleteTicker: true }));
        dispatch(deleteTicker(portfolioId, ticker))
        .finally(() => {
            setLoadingState(prev => ({ ...prev, deleteTicker: false }));
            TagManager.dataLayer({
                dataLayer: {
                  'event': 'Delete Ticker',
                  'userType':sessionStorage.getItem("selectedAcType"),
                  'user_id': sessionStorage.getItem("clientId")
                },
              });
        });
    };

    if (portfolioDetails.isLoading) {
        return (
            <div className="details-table-container" style={{ height: "300px" }}>
                <div className="loading-overlay">
                    <BeatLoader color="#60034C" loading size={10} />
                </div>
            </div>
        );
    }

    const open = Boolean(anchorEl);
    const handleActionClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    function renderPortfolioDetails(portfolioDetails, loadingState) {
        if (loadingState.addTicker || loadingState.deleteTicker) {
            return (
                <tr>
                    <td colSpan="7">
                        <div className="details-table-container " style={{ height: "300px" }}>
                            <div className="loading-overlay">
                                <BeatLoader color="#60034C" loading={true} size={30} />
                            </div>
                        </div>
                    </td>
                </tr>
            );
        }
        if (portfolioDetails && portfolioDetails.PortfolioLineItem && Array.isArray(hedgeableFlag?portfolioDetails.PortfolioLineItem.Unhedgeable:portfolioDetails.PortfolioLineItem.Hedgeable)) {
            const totalPortfolioValue = parseFloat(portfolioDetails?.TotalPortfolioValue ?? '0');
            const portfolioLineItems = hedgeableFlag?portfolioDetails.PortfolioLineItem.Unhedgeable: portfolioDetails.PortfolioLineItem.Hedgeable;
            return portfolioLineItems.map(item => {
                const marketValue = item.Quantity * item.ClosePrice;
                const marketWeight = (marketValue / totalPortfolioValue) * 100;
            return (
                <tr key={item.SecId}>
                    <td>{item.Ticker}</td>
                    <td>{item.CompanyName}</td>
                    <td>{Number(addZeroes(Number(parseFloat(item.Quantity).toFixed(2)))).toLocaleString("en-US")}</td>
                    <td>{item.ClosePrice==='-'?item.ClosePrice:'$'+item.ClosePrice.toFixed(2).toLocaleString("en-US", currObj)}</td>
                    <td>
                        {!isNaN(marketValue)?Number(addZeroes(Number(parseFloat(marketValue).toFixed(2)))).toLocaleString("en-US", currObj):'-'}
                    </td>
                    <td>{!isNaN(marketWeight)?marketWeight.toFixed(2)+'%':'-'}</td>
                    {/* <td>${(item.ClosePrice - item.YesterdaysClose).toFixed(2).toLocaleString("en-US", currObj)}</td> */}
                    {/* <td>{item.RiskToday.toFixed(2)}%</td> */}
                    {/* <td>{(item.RiskToday - item.RiskYesterday).toFixed(2)}%</td> */}
                    {!hasSchwabAccount && ( 
                    <td>
                        <button className='deleterow' onClick={() => handleDeleteTicker(item.Ticker)}>
                            <img src="./Assets/trash.svg" alt="Delete" />
                        </button>
                    </td>
                    )}
                </tr>
            );
        });
        } else {
            return (
                <tr>
                    <td colSpan="7">Portfolio is Empty.</td>
                </tr>
            );
        }
    }

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handlePortfolioDelete = (portfolioid) => {
        handleClose();
        dispatch(showConfirmNotification("Are you sure you want to delete this portfolio ?", () => confirmDelete(portfolioid)));
    };

    const confirmDelete = async (portfolioid) => {
        setLoadingState(prev => ({ ...prev, fetchDetails: true }));
        setConfirmPopup(false);
        const data = await DeletePortfolio(portfolioid);
        if (data.status === 200) {
            TagManager.dataLayer({
                dataLayer: {
                  'event': 'Portfolio Deleted',
                  'userType':sessionStorage.getItem("selectedAcType"),
                  'user_id': sessionStorage.getItem("clientId")
                },
              });
            dispatch(fetchPortfolio());
        } else {
            handleApiError(data, dispatch);
        }
        setLoadingState(prev => ({ ...prev, fetchDetails: false }));
    };


    return (
        <>
            <div className="toast-container">
                <Toaster />
            </div>
            {loadingState.fetchDetails || !portfolioDetails || loadingState.addTicker || loadingState.deleteTicker ? (
                <div className="details-table-container " style={{ height: "300px" }}>
                    <div className="loading-overlay">
                        <BeatLoader color="#60034C" loading={true} size={10} />
                    </div>
                </div>
            ) : (
                <>
                    <div className='portfolio-header-container' >
                        <div className='portfolio-details'>
                            <div className='switchcontent'>
                                Hedgeable Assets
                                <div className="toggle-switch">
                                    <input type="checkbox" checked={hedgeableFlag} onChange={() => toggleHedgeableFlag()}></input>
                                    <span className='slider'></span>
                                </div>
                                Unhedgeable Assets
                            </div>
                            <span className='portfolio-stocks'>
                                HOLDINGS: {hedgeableFlag?portfolioDetails.details?.PortfolioLineItem?.Unhedgeable?.length ?? '0' :portfolioDetails.details?.PortfolioLineItem?.Hedgeable?.length ?? '0'}
                            </span>
                            <span className='portfolio-value'>
                                PORTFOLIO VALUE: {Number(
                                        addZeroes(Number(parseFloat(portfolioDetails.details?.TotalPortfolioValue ?? '0').toFixed(2)))
                                    ).toLocaleString("en-US", currObj)}
                            </span>
                            {!hasSchwabAccount && (
                                <button className='pf-action-button' onClick={(e) => handleActionClick(e)}>
                                    Actions <span className="arrow-down" />
                                </button>
                            )}
                        </div>
                        <Popover
                            open={open}
                            anchorEl={anchorEl}
                            onClose={handleClose}
                            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                        >
                            <div className="popoverContainer">
                                <button
                                    onClick={() => {
                                        dispatch(openDrawer('EditPortfolio', { portfolioDetails: portfolioDetails.details?.PortfolioLineItem?.Hedgeable?.length > 0 ? portfolioDetails.details : {PortfolioId:portfolioId,PortfolioName:portfolioName}  }));
                                        handleClose();
                                    }}
                                    className="popoverButton"
                                >
                                    <span>Edit Portfolio</span>
                                    <img className="product_card_img" src='./Assets/Typing.svg' alt="Edit" />
                                </button>
                                <button
                                    onClick={() => handlePortfolioDelete(portfolioId)}
                                    className="popoverButton"
                                >
                                    <span>Delete Portfolio</span>
                                    <img className="product_card_img" src="./Assets/trash.svg" alt="Delete" />
                                </button>
                            </div>
                        </Popover>
                    </div>
                    <table className='portfoliotikers'>
                        <thead>
                            <tr>
                                <th>SYMBOL</th>
                                <th>DESCRIPTION</th>
                                <th>QUANTITY</th>
                                <th>PRICE</th>
                                <th>MARKET VALUE</th>
                                <th>MARKET WEIGHT</th>
                                {/* <th>PRICE CHANGE (LAST MARKET CLOSE)</th> */}
                                {/* <th>RISK %</th> */}
                                {/* <th>CHANGE IN RISK (LAST CLOSE) %</th> */}
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {renderPortfolioDetails(portfolioDetails.details, loadingState)}
                            {!hasSchwabAccount && ( 
                                <tr className="table-footer">
                                    <td colSpan={8}>
                                        <div className='addticker'>
                                            <input
                                                type="text"
                                                placeholder="Symbol"
                                                className='ai-form-value'
                                                value={ticker}
                                                onChange={handleTickerChange}
                                            />
                                            <input
                                                type="number"
                                                placeholder="Quantity"
                                                className='ai-form-value'
                                                value={quantity}
                                                onChange={handleQuantityChange}
                                                step="any"
                                            />
                                            <button className='' onClick={handleAddTicker}>+</button>
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                        <tr>
                            {errorMessage && <ErrorComponent message={errorMessage} />}
                        </tr>
                    </table>
                </>
            )}
        </>
    );
}

export default PortfolioDetails;
